<template>
  <div class="default-select" :class="{ cursorNotAllowed: disabled, scroll: scroll }">
    <div class="selected" :class="{ open: open, disabled: disabled, focus: focus }" @blur="blur()" @click="openSelect()">
      <div class="select-wrapper" >
        <span class="label m-subhead-m">{{ label }}</span>
        <input ref="searchInput"
               v-on:input="$emit('input', $event.target.value)"
               class="search-input m-body-m"
               type="text"
               v-mask="mask"
               v-filter:[filter]
               :inputmode="inputmode"
               :value="value"
               @blur="blur(); $emit('blur')"
               @click="onFocus()"
               @keyup="openSelect()"/>
      </div>

      <div class="icon">
        <img src="@/assets/icons/arrow-bottom.svg" alt="icon">
      </div>
    </div>

    <div class="items" :class="{ selectHide: !open }">
      <span class="item m-body-m"
            v-for="(option, i) of filterOptions"
            :key="i"
            @mousedown="changeItem(option.name, option.optionId)"
      >
         {{ option.name }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    options: {
      type: Array
    },
    disabled: {
      type: Boolean,
      default: false
    },
    tabindex: {
      type: Number,
      default: 0
    },
    scroll: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String, Number],
      default: ''
    },
    inputmode: {
      type: String,
      default: 'text'
    },
    mask: {
      default: ''
    },
    filter: {
      default: false
    }
  },
  data () {
    return {
      open: false,
      focus: false
    }
  },
  computed: {
    filterOptions: function () {
      const searchItem = this.value
      function filterItem (items) {
        const regexp = new RegExp(searchItem, 'y')
        return regexp.test(items.name)
      }

      return this.options.filter(filterItem)
    }
  },
  methods: {
    openSelect: function () {
      this.open = Boolean(this.filterOptions.length)
    },
    changeItem: function (name, id) {
      this.$emit('input', name)
      this.open = false
      this.$emit('input', id)
    },
    blur: function () {
      this.open = false
      this.focus = false
      const found = this.options.find(element => element.name === this.value)
      if (!found) {
        this.$emit('input', '')
      }
    },
    onFocus: function () {
      this.focus = true
    }
  }
}
</script>

<style lang="less" scoped>
.default-select {
  position: relative;
  &:focus {
    outline: none;
    .selected {
      border: 1px solid var(--second-base);
    }
  }

  .selected.focus {
    border: 1px solid var(--second-base);
  }

  .selected {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 4px 8px;
    height: 56px;
    border: 1px solid var(--grey-220);
    box-sizing: border-box;
    border-radius: var(--default-br);
    cursor: pointer;

    &.open .icon {
      transform: rotate(180deg);
    }

    .name {
      display: flex;
      height: 24px;
    }

    .search-input {
      display: flex;
      align-items: center;
      padding: 0;
      width: 100%;
      height: 24px;
      border: none;
      background: transparent;

      &::placeholder {
        color: var(--grey-180);
      }

      &:focus {
        border: none;
        outline: none;
      }
    }
  }

  .selected.disabled {
    background: var(--grey-240);
    pointer-events: none;
    border: none;

    .label {
      color: var(--grey-200);
    }

    .name {
      color: var(--grey-200);
    }

    .icon {
      opacity: 0.4;
    }

    &:hover {
      .label {
        color: var(--grey-200);
      }
    }
  }

  .icon {
    width: 24px;
    height: 24px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .select-wrapper {
    width: 100%;
  }

  .label {
    display: flex;
    align-items: center;
    width: 100%;
    height: 20px;
    color: var(--grey-140);
  }

  &:hover {
    .label {
      color: var(--black);
    }
  }

  .items {
    position: absolute;
    z-index: 100;
    top: 60px;
    left: 0;
    width: 100%;
    max-height: 244px;
    overflow-y: scroll;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    padding: 0 8px;
    background: var(--white);
    border: 1px solid var(--grey-220);
    box-sizing: border-box;
    box-shadow: 0 1px 4px #DCE1E6;
    border-radius: var(--default-br);

    .item {
      display: flex;
      width: 100%;
      padding: 12px 8px;
      color: var(--black);
      cursor: pointer;

      &:hover {
        background: var(--grey-250);
      }
    }
  }

  .items.selectHide {
    display: none;
  }

  &.scroll .items {
    height: 150px;
    display: block;
    overflow-y: auto;
    overflow-x: hidden;
  }

  &.scroll .items.selectHide {
    display: none;
  }
}

.default-select.cursorNotAllowed {
  cursor: not-allowed;

  &:focus {
    outline: none;
    .selected {
      border: none;
    }
  }
}
</style>
